import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import { SupraSystemSubscriptionStatus } from '@bb/domain/dist/types';

type SupraTagProps = {
  status?: SupraSystemSubscriptionStatus;
};

const supraSystemSubscriptionStatusMap: Record<
  SupraSystemSubscriptionStatus,
  string
> = {
  [SupraSystemSubscriptionStatus.subscribed]: 'Subscribed',
  [SupraSystemSubscriptionStatus.unsubscribed]: 'Unsubscribed',
  [SupraSystemSubscriptionStatus.pending]: 'Pending',
  [SupraSystemSubscriptionStatus.suspended]: 'Suspended',
  [SupraSystemSubscriptionStatus.deactivated]: 'Deactivated',
};

const SupraTag: React.FC<SupraTagProps> = ({
  status = SupraSystemSubscriptionStatus.unsubscribed,
}) => {
  const colorMap: Record<SupraSystemSubscriptionStatus, string | undefined> = {
    pending: 'orange',
    subscribed: 'green',
    unsubscribed: undefined,
    suspended: 'yellow',
    deactivated: 'red',
  };

  return (
    <StyledTag color={colorMap[status]}>
      {supraSystemSubscriptionStatusMap[status]}
    </StyledTag>
  );
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default SupraTag;
